import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@app/user/user.service';
import { AuthenticationService } from '@app/_services';
import { SharedUtilService } from '@app/_shared/shared-util.service';
import { constants, errorMessages } from '@assets/data/constants';
import { ToastrService } from 'ngx-toastr';
import { PerformanceService } from '../performance.service';
import { TestCaseService } from '@app/testcase/testcase.service';

@Component({
  selector: 'app-queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.less']
})
export class QueueComponent implements OnInit {

  userData: any = {};
  queueData: any = [];
  queryParams: any;
  previousPage: any;
  userProjects = [];
  projectUsers = [];
  testCompleted: boolean;
  executionStatuses = [];
  abortTriggered: boolean;
  searchQueueForm: FormGroup;
  openFilter: boolean = false;
  sortDirection = true;
  direction: string = 'asc';

  page = 1;
  pageSize = 15;
  advanceSearch = {
    page: '1',
    size: '15',
    projectIds: [],
    userIds: [],
    executionStatus: null,
    keyword: null,
    userName:null,
  };

  constructor(private titleService: Title, private userService: UserService, private toastr: ToastrService, private performanceService: PerformanceService,
    private router: Router, private route: ActivatedRoute, private authService: AuthenticationService,
    private sharedUtilService: SharedUtilService, private TestCaseServices: TestCaseService) { }

  ngOnInit() {
    this.titleService.setTitle('Perf | Queue');
    this.initiateSearchQueueForm();
    this.route.queryParams.subscribe(params => { this.getQueue(params); });
    this.userData = this.authService.currentUserValue;
    this.executionStatuses = JSON.parse(localStorage.getItem('about')).executionStatuses;

    this.getUserProject();
    this.pageSize =  this.queryParams.size;
  }

  initiateSearchQueueForm() {
    this.searchQueueForm = new FormGroup({
      projectIds: new FormControl(),
      userIds: new FormControl(),
      executionStatus: new FormControl(),
      keyword: new FormControl(),
      userName: new FormControl(),
    });
  }

  getUserProject() {
    this.userService.getMyProjectList().subscribe(data => {
      if (data.code === 200) {
        this.userProjects = data.response;
      } else {
        this.toastr.error(errorMessages.userProjectsError + data.message);
      }
    });
  }

  getQueue(searchParams) {
    this.queryParams = Object.assign({}, this.advanceSearch);
    this.queryParams.page = searchParams.page ? searchParams.page : this.queryParams.page;
    this.queryParams.size = searchParams.size ? searchParams.size : this.queryParams.size;
    this.queryParams.executionStatus = searchParams.executionStatus ? searchParams.executionStatus : null;
    this.queryParams.keyword = searchParams.keyword ? searchParams.keyword : null;
    this.queryParams.userName = searchParams.userName ? searchParams.userName : null;
    this.queryParams.projectIds = searchParams.projectIds ? searchParams.projectIds : [];
    this.queryParams.userIds = searchParams.userIds ? searchParams.userIds : [];

    this.setSearchFromParams(this.queryParams)
    this.getUsersByProject(this.queryParams.projectIds)
    this.performanceService.getQueueList(this.queryParams).subscribe(data => {
      if (data.code === 200) {
        this.queueData = data.response;
        this.page = this.queryParams.page;
      } else {
        this.queueData = {
          count: 0,
          performanceRequests: []
        };
        this.toastr.error(errorMessages.queueListError + data.message);
      }
    });
  }

  getUsersByProject(projectIds) {
    if (!projectIds || projectIds.length === 0) {
      this.searchQueueForm.controls.userIds.reset();
      return;
    }
    if (projectIds || projectIds.length !== 0) {
      this.searchQueueForm.controls.userName.reset();
    }
    const projects = {
      projectIds
    };
    this.performanceService.getUsersByProject(projects).subscribe(data => {
      if (data.code === 200) {
        this.projectUsers = data.response;

        if (this.userIdsValue) {
          this.searchQueueForm.controls.userIds
            .setValue(this.userIdsValue.filter(user => this.projectUsers.some(projUser => projUser.id === user)));
        }
      } else {
        this.projectUsers = [];
      }
    });
  }

  searchQueue(searchQueue) {
    const searchParams = Object.assign({}, this.advanceSearch);
    searchParams.projectIds = searchQueue.projectIds;
    searchParams.userIds = searchQueue.userIds;
    searchParams.executionStatus = searchQueue.executionStatus;
    searchParams.keyword = searchQueue.keyword;
    searchParams.userName = searchQueue.userName;

    this.router.navigate(['.'], { relativeTo: this.route, queryParams: searchParams });
  }

  clearFilterQueue() {
    this.searchQueueForm.reset();
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: { page: 1, size: 15 } });
  }

  abortRunningTest(queueId) {
    // const id = queueId;
    this.performanceService.abortResults(queueId).subscribe(data => {
      if (data.code === 200) {
        this.abortTriggered = true;
        this.toastr.success(data.message);
        // if (queueId) {
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: this.queryParams });
        // } else {
        // this.testCompleted = true;
        // }
      } else {
        this.abortTriggered = false;
        this.toastr.error(data.message);
      }
    });
  }

  deleteQueueRes(queueId) {
    this.sharedUtilService.openConfirmDialog(constants.deleteQueueResult, false).then((result) => {
      if (result) {
        this.performanceService.deleteQueueResult(queueId).subscribe(data => {
          if (data.code === 200) {
            this.toastr.success(data.message);
            this.getQueue(this.queryParams);
          } else {
            this.toastr.error(data.message);
          }
        });
      }
    });
  }

  onSizeChange(pageSize) {
    this.pageSize = pageSize;
    this.queryParams.size = this.pageSize;
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: this.queryParams });
  }

  onPageChange(page) {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.queryParams.page = this.page;
      this.router.navigate(['.'], { relativeTo: this.route, queryParams: this.queryParams });
    }
  }

  refreshList() {
    let params = Object.assign({}, this.queryParams);
    if (this.queryParams === undefined || !this.queryParams) {
      params = this.advanceSearch;
    }
    Object.keys(params).forEach(key => {
      if (params[key] === undefined || !params[key] || params[key].length === 0) { delete params[key]; }
    });
    this.getQueue(params);
  }

  // GETTERs
  get projectIdsValue() {
    return this.searchQueueForm.controls.projectIds.value;
  }

  get userIdsValue() {
    return this.searchQueueForm.controls.userIds.value;
  }

  setSearchFromParams(params){
    if (params.executionStatus) { this.searchQueueForm.get('executionStatus').setValue(params.executionStatus); }
    if (params.keyword) { this.searchQueueForm.get('keyword').setValue(params.keyword); }
    if (params.userName) { this.searchQueueForm.get('userName').setValue(params.userName); }

    if (params.projectIds) {
      let projects = [];
      if (Array.isArray(params.projectIds)) {
        projects = params.projectIds.map((val: string) => {
          return parseInt(val, 10);
        });
      } else {
        const projectId = parseInt(params.projectIds, 10);
        projects.push(projectId);
      }
      this.searchQueueForm.get('projectIds').setValue(projects);
    }

    if (params.userIds) {
      let users = [];
      if (Array.isArray(params.userIds)) {
        users = params.userIds.map((val: string) => {
          return parseInt(val, 10);
        });
      } else {
        const userId = parseInt(params.userIds, 10);
        users.push(userId);
      }
      this.searchQueueForm.get('userIds').setValue(users);
    }

  }
  getTestCaseList(id:number) {
    this.TestCaseServices.getTestCaseListById(id).subscribe({
      next: (response) => {
        const url = `/#relay/testcase/${id}`;
        window.open(url, '_blank');
      },
      error: (error) => {
        this.toastr.error('Testcase not Found')
      }
    })
  }

  sortByColumn(columnName: string) {

    this.direction = (this.sortDirection) ? 'desc' : 'asc';
    let sortedArray;
    if (columnName === 'name') {
      sortedArray = (this.queueData.performanceRequests || []).sort((a, b) => {
        let val1 = a.testCase[columnName].toLowerCase();
        let val2 = b.testCase[columnName].toLowerCase();
        if (val1 > val2) {
          return (this.direction === 'asc') ? 1 : -1;
        }
        if (val1 < val2) {
          return (this.direction === 'asc') ? -1 : 1;
        }
        return 0;
      })

    } else if (columnName === 'userName') {
      sortedArray = (this.queueData.performanceRequests || []).sort((a, b) => {
        let val1 = a.createdBy[columnName].toLowerCase();
        let val2 = b.createdBy[columnName].toLowerCase();
        if (val1 > val2) {
          return (this.direction === 'asc') ? 1 : -1;
        }
        if (val1 < val2) {
          return (this.direction === 'asc') ? -1 : 1;
        }
        return 0;
      })

    }
    else {
      sortedArray = (this.queueData.performanceRequests || []).sort((a, b) => {
        if (a[columnName] > b[columnName]) {
          return (this.direction === 'asc') ? 1 : -1;
        }
        if (a[columnName] < b[columnName]) {
          return (this.direction === 'asc') ? -1 : 1;
        }
        return 0;
      })
    }
    this.sortDirection = !this.sortDirection;
    this.queueData.performanceRequests = sortedArray;
  }

}
